
import React from 'react';
import { ModalConfirm } from 'oolib';


export const ConfirmDeleteModal = ({
    showDeleteImageModal,
    setShowDeleteImageModal,
    handleDeleteSingleImage
}) => {
    return (
        <ModalConfirm
          title="Are you sure you want to delete this image?"
          subTitle="Once you delete an image it cannot be undone"
          onClose={() => {
            setShowDeleteImageModal(false);
          }}
          onConfirm={() => {
            handleDeleteSingleImage({
              publicUrl: showDeleteImageModal.publicUrl,
            });
            setShowDeleteImageModal(false);
          }}
        />
    )
}


